import { Title } from 'components/commons';
import coneIcon from 'assets/svg/cone.svg';

const ErrorPage: React.FC = () => {
    return (
        <div className="message-box-container">
            <div className="inner">
                <div className="screen">
                    <div className="message-box">
                        <img className="icon" src={coneIcon} />
                        <Title>
                            ops, tivemos <br className="d-block d-md-none" />algum problema!
                        </Title>
                        <p className="text">
                            Estamos verificando o que pode ter acontecido.
                        </p>
                        <p className="text">
                            Se você não encontrar o que estava procurando ou estiver com alguma dúvida, fala com a gente!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ErrorPage;
